import * as React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { App } from "./App";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      children: [
        {
          path: "/:part",
          element: <h1>Howdy</h1>,
        },
      ],
    },
  ],
  {
    basename: "/map-of-react-api",
  }
);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<RouterProvider router={router} />);
